import type { CSSProperties, FC } from 'react'

export interface TableTextCellProps {
    kind?: 'delete' | 'info' | 'comment'
    children:
        | string
        | number
        | JSX.Element
        | Array<string | number | JSX.Element>
    style?: CSSProperties
    title?: string
    onClick?: React.MouseEventHandler<HTMLElement>
    containerRef?: React.RefObject<HTMLTableCellElement>
    // So e2e scenes can select a cell without depending on its text.
    'data-testid'?: string
}

export const TableTextCell: FC<TableTextCellProps> = ({
    kind = 'info',
    children,
    style,
    onClick,
    title,
    containerRef,
    'data-testid': dataTestId,
}) => {
    return (
        <td
            ref={containerRef}
            className={`table-cell table-cell_${kind}`}
            title={title}
            data-testid={dataTestId}
            onClick={onClick}>
            <span style={style}>{children}</span>
        </td>
    )
}
